import { FC, ReactNode } from 'react';
import { ContentResponse } from '../../types/shared';
import { YoutubeBlockResponse } from '../../types/blocks';
import styles from './YoutubeBlock.module.css';
import { useAtomValue } from 'jotai';
import { hydratedOneTrustActiveGroupsAtom } from '@/features/tagManagement/tagManagementStore';
import OneTrustCookieIdCategories from '@/features/tagManagement/OneTrustCookieIdCategories';
import { Link, SystemBanner } from '@kpa/kul';

interface IYoutubeBlock {
  contentResponse: ContentResponse;
}

const YoutubeBlock: FC<IYoutubeBlock> = ({
  contentResponse,
}): ReactNode => {
  const youtubeBlockResponse = contentResponse.content as YoutubeBlockResponse;

  const hydratedOneTrustActiveGroups = useAtomValue(hydratedOneTrustActiveGroupsAtom);
  const hasAcceptedFunctionalCookies = hydratedOneTrustActiveGroups?.includes(
    OneTrustCookieIdCategories.Funktionella,
  ) ?? false;

  return hasAcceptedFunctionalCookies
    ? (
        <div
          className={styles.youtubeBlockIframeContainer}
          style={{ aspectRatio: youtubeBlockResponse.bildförhållande }}
        >
          <iframe
            // Även youtube-nocookie.com-domänen nedan sätter youtube-kaka (men begränsad spårning till när besökaren spelar upp videon), så därför vi kräver accepterande cookies.
            src={`https://www.youtube-nocookie.com/embed/${youtubeBlockResponse.videoId}?rel=0&start=${youtubeBlockResponse.startMinuter * 60}`}
            title="YouTube-video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            style={{ border: 0 }}
          />
        </div>
      )
    : (
        <div>
          <SystemBanner
            variant="information"
            title="YouTube-film dold"
            ariaLive="polite"
            roleAlert={false}
          >
            <p>
              För att kunna se
              {' '}
              <Link
                href={`https://www.youtube.com/watch?v=${youtubeBlockResponse.videoId}&t=${youtubeBlockResponse.startMinuter * 60}`}
                target="_blank"
                showLinkIcon={true}
                iconName="IconExternalLink"
                iconSize="small"
                displayIconRight={true}
              >
                filmen
              </Link>
              {' '}
              behöver du godkänna Funktionella cookies.
            </p>
            <p>
              <Link
                onClick={() => window.OneTrust && window.OneTrust.ToggleInfoDisplay()}
                actionLink={true}
              >
                Ändra inställningar för cookies
              </Link>
            </p>
          </SystemBanner>
        </div>
      );
};

export default YoutubeBlock;
